<template>
  <div @mouseleave="$emit('closeMegaMenu')">
    <DesktopMegaMenu
      v-if="showMenu"
      :categories="categories"
      :getCategoryDetails="getCategoryDetails"
      :openCategorySearch="openCategorySearch"
      @closeMegaMenu="$emit('closeMegaMenu')"
    />
    <MobileMegaMenu
      v-if="showMenu"
      :categories="categories"
      :getCategoryDetails="getCategoryDetails"
      :openCategorySearch="openCategorySearchMobile"
      @closeMegaMenu="$emit('closeMegaMenu')"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import MobileMegaMenu from './mobile/Menu.vue'
import DesktopMegaMenu from './desktop/Menu.vue'

export default {
  name: 'MegaMenu',
  components: {
    MobileMegaMenu,
    DesktopMegaMenu,
  },
  props: {
    showMenu: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      categories: 'categories/categories',
    }),
  },
  methods: {
    getCategoryDetails(category) {
      switch (category) {
        case 'Networking':
          return {
            name: require('@/assets/images/mega-menu/name_networking.png'),
            background: require('@/assets/images/mega-menu/bg_networking.jpg'),
            topics: [
              { name: 'Routing & Switching', queryType: 'category' },
              { name: 'Cisco', queryType: 'vendor' },
              { name: 'Data Center', queryType: 'category' },
              { name: 'Service Provider', queryType: 'category' },
            ],
          }
        case 'Development':
          return {
            name: require('@/assets/images/mega-menu/name_development.png'),
            background: require('@/assets/images/mega-menu/bg_development.jpg'),
            topics: [
              { name: 'Automation & Systems', queryType: 'vendor' },
              { name: 'Python', queryType: 'category' },
              { name: 'Java', queryType: 'category' },
              { name: 'Cloud Security Alliance', queryType: 'category' },
            ],
          }
        case 'Security':
          return {
            name: require('@/assets/images/mega-menu/name_security.png'),
            background: require('@/assets/images/mega-menu/bg_security.jpg'),
            topics: [
              { name: 'Cyber Ops', queryType: 'category' },
              { name: 'Offensive Security', queryType: 'category' },
              { name: 'Cisco', queryType: 'vendor' },
              { name: 'Security+', queryType: 'category' },
            ],
          }
        case 'General IT':
          return {
            name: require('@/assets/images/mega-menu/name_general-it.png'),
            background: require('@/assets/images/mega-menu/bg_general-it.jpg'),
            topics: [
              { name: 'Other Technologies', queryType: 'category' },
              { name: 'Blockchain', queryType: 'category' },
              { name: 'Linux', queryType: 'category' },
              { name: 'A+', queryType: 'category' },
            ],
          }
        case 'Data Science':
          return {
            name: require('@/assets/images/mega-menu/name_data-science.png'),
            background: require('@/assets/images/mega-menu/bg_data-science.jpg'),
            topics: [],
          }
        case 'Cloud':
          return {
            name: require('@/assets/images/mega-menu/name_cloud.png'),
            background: require('@/assets/images/mega-menu/bg_cloud.jpg'),
            topics: [
              { name: 'Amazon Web Services', queryType: 'category' },
              { name: 'VMware', queryType: 'category' },
              { name: 'Docker', queryType: 'category' },
              { name: 'Ansible', queryType: 'category' },
            ],
          }
        default:
          return {}
      }
    },
    openCategorySearch(query) {
      this.$store.dispatch('search/setSearchQuery', '')
      if (query.queryType === 'vendor') {
        this.$router.push({ name: 'search', query: { vendor: query.name } })
      } else {
        this.$router.push({ name: 'search', query: { category: query.name } })
      }
      this.$emit('closeMegaMenu')
    },
    openCategorySearchMobile(query) {
      this.$store.dispatch('search/setSearchQuery', query.name)
      this.$router.push({ name: 'search' })
      this.$emit('closeMegaMenu')
    },
    closeMegaMenu() {
      this.$emit('closeMegaMenu')
    },
  },
}
</script>
